import React from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Select from 'react-select';

export const FilterByDay = ({
  anualFilters,
  setAnualFilters,
  options,
  isDisabled,
  title
}) => {
  const handleChange = selectedOption => {
    setAnualFilters(state => ({
      ...state,
      filterType: Number(selectedOption.value)
    }));
  };

  const selectOptions = options.map(type => ({
    value: type.value,
    label: type.label
  }));

  return (
    <Form.Group>
      {title && <Form.Label>{title}</Form.Label>}

      <Select
        options={selectOptions}
        value={selectOptions.find(
          option => option.value === anualFilters.filterType
        )}
        onChange={handleChange}
        isDisabled={isDisabled}
      />
    </Form.Group>
  );
};

FilterByDay.propTypes = {
  setAnualFilters: PropTypes.func.isRequired,
  anualFilters: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  isDisabled: PropTypes.bool,
  title: PropTypes.string
};
